<template>
  <v-form
    ref="editThirdPartyWorksForm"
    v-model="isFormValid"
    class="third-party-works-dialog"
    lazy-validation
    @submit.prevent="submitForm"
  >
    <label class="input-label">Tytuł utworu:</label>
    <v-text-field
      v-model="thirdPartyWork.title"
      v-bind="props.textField"
      height="40"
      class="third-party-works-dialog__input"
      :rules="[rules.required]"
    />

    <label class="input-label">Autor utworu:</label>
    <v-text-field
      v-model="thirdPartyWork.author"
      v-bind="props.textField"
      height="40"
      class="third-party-works-dialog__input"
      :rules="[rules.required]"
    />

    <label class="input-label">Informacje o prawach:</label>
    <v-textarea
      v-model="thirdPartyWork.info"
      v-bind="props.textField"
      :rules="[rules.required]"
      height="false"
      no-resize
      class="third-party-works-dialog__input third-party-works-dialog__textarea"
    />

    <v-btn
      class="custom-submit-button mt-0"
      color="primary"
      depressed
      :loading="isFormProcessing"
      type="submit"
    >
      Zapisz utwór
    </v-btn>
  </v-form>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      props,
      rules,
      isFormValid: true,
      thirdPartyWork: {
        title: null,
        author: null,
        info: null,
      },
    };
  },

  computed: {
    ...mapState('metrics', [
      'isFormProcessing',
    ]),
    ...mapGetters('metrics', [
      'getThirdPartyWorksSingle',
    ]),
  },

  created() {
    this.thirdPartyWork = { ...this.getThirdPartyWorksSingle(this.id) };
  },

  methods: {
    ...mapActions('metrics', [
      'editThirdPartyWorks',
    ]),
    submitForm() {
      this.$refs.editThirdPartyWorksForm.validate();
      if (this.isFormValid) {
        this.editThirdPartyWorks({ id: this.id, ...this.thirdPartyWork });
      }
    },
  },
};
</script>
